import type { FunderRateSettingsUpdateWire } from '@klear/funder/funder.wire'

type FunderRateSettingsUpdateInput = {
  id: number
  data: FunderRateSettingsUpdateWire
}

export type FunderRateSettingsForm = {
  funderRate: number
  supportsIG: boolean
  supportsInsured: boolean
}

type FunderRateSettingsFormSource = {
  funderRate?: number | null
  supportsIG?: boolean | null
  supportsInsured?: boolean | null
}

export function funderReadToRateSettingsForm(source: FunderRateSettingsFormSource): FunderRateSettingsForm {
  return {
    funderRate: source.funderRate ?? 0,
    supportsIG: source.supportsIG ?? false,
    supportsInsured: source.supportsInsured ?? false
  }
}

export function funderRateSettingsFormToUpdateWire(
  form: FunderRateSettingsForm,
  id: number
): FunderRateSettingsUpdateInput {
  return {
    id,
    data: {
      funderRate: form.funderRate,
      supportsIG: form.supportsIG,
      supportsInsured: form.supportsInsured
    }
  }
}
